// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"322":"255e3193","453":"3cf12bc3","625":"1370c112","832":"396f2dce","869":"5e13cd5f","875":"0895f63c","879":"0183f2ac","908":"58991971"}[chunkId] + ".chunk.js";
};